import { useMutation } from "@tanstack/react-query";
import { useCallback, useState } from "react";

import appendToFormData from "Utilities/appendToFormData";
import { generateUUID } from "Utilities/generateUUID";

const useFileMutation = ({ mutationFn, additionFormData, ...rest }) => {
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  const onUploadProgress = useCallback(({ loaded, total }) => {
    setProgressPercentage(loaded / total);
  }, []);

  return {
    ...useMutation({
      mutationFn: (file) => {
        const formData = new FormData();
        formData.append("qquuid", generateUUID());
        formData.append("qqfilename", file.name);
        formData.append("qqtotalfilesize", file.size);
        formData.append("qqfile", file);
        appendToFormData(formData, additionFormData);

        try {
          return mutationFn(formData, onUploadProgress);
        } catch (e) {
          setErrorMessage(e.message);
        }
      },
      ...rest,
    }),
    progressPercentage,
    errorMessage,
  };
};

export default useFileMutation;
